import React, { useContext, useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { Dropdown } from 'react-bootstrap'
import { useLazyQuery, useMutation } from '@apollo/client'

import { TOAST_TYPE } from '@shared-submodule/sm-constants'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { clearCookie, getImgURL } from '@shared-submodule/utils'
// import userImg from '@assets/images/placeholder/person-placeholder.jpg'
import { SIGN_OUT } from '@graphql/auth/signout.mutation'
import { setCurrentUser } from '@shared-submodule/sm-libs/menu'
import ToastrContext from '@shared/components/toastr/ToastrContext'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'
import { GET_USER } from '@graphql/profile/profile.query'
import { getToken, setToken } from '@shared/libs/token'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'
import { UserProfileIcon } from '@shared/components/ctIcons'
import ProfilePlaceholder from '@assets/images/placeholder/ProfilePlaceholder.svg'
// const CustomLink = dynamic(() => import('@shared/components/customLink'))
const SocialAuthModal = dynamic(() => import('@shared/components/socialAuthModal'), { ssr: false })
const GlobalSearch = dynamic(() => import('@shared/components/searchComponents/globalSearch'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
const SearchModal = dynamic(() => import('@shared/components/searchModal'))

function HeaderUser({ styles }) {
  const { t } = useTranslation()
  const router = useRouter()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userData, setUserData] = useState({})
  const [modalShow, setModalShow] = useState(false)
  const [searchModalShow, setSearchModalShow] = useState(false)
  const { dispatch } = useContext(ToastrContext)
  const { stateGlobalEvents, dispatchGlobalEvents: editProfileEvent } = useContext(GlobalEventsContext)
  const token = getToken()
  const [width] = useWindowSize()

  const [getUser, { data }] = useLazyQuery(GET_USER, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      setUserValue(data)
    }
  })

  useEffect(() => {
    if (token && modalShow) {
      setModalShow(false)
    }
  }, [token])

  const [signOut] = useMutation(SIGN_OUT, {
    onCompleted: (data) => {
      if (data && data.userLogout) {
        setToken(undefined)
        clearCookie()
        sessionStorage.clear()
        setIsAuthenticated(false)
        setCurrentUser(null)
        setUserData({})
        if (router.asPath === allRoutes.profile || router.asPath === allRoutes.saveForLater || router.asPath === allRoutes.profileEdit) {
          router.push(allRoutes.home)
        }
        // router.replace(allRoutes.home)
        dispatch({
          type: 'SHOW_TOAST',
          payload: { message: data?.userLogout?.sMessage, type: TOAST_TYPE.Success }
        })
        editProfileEvent({
          type: 'CHANGE_PROFILE',
          payload: { profileData: null }
        })
      }
    }
  })

  useEffect(() => {
    if (stateGlobalEvents && stateGlobalEvents.profileData) {
      setUserData({ ...stateGlobalEvents.profileData })
    }
  }, [stateGlobalEvents])

  useEffect(() => {
    isAuthenticated && getUser()
  }, [isAuthenticated])

  const handleSignOut = () => {
    signOut()
  }

  useEffect(() => {
    if (getToken()) {
      setIsAuthenticated(true)
      setUserData(data?.getUser)
      setCurrentUser(data?.getUser)
    } else {
      setIsAuthenticated(false)
    }
  }, [setIsAuthenticated, handleSignOut])

  function setUserValue(data) {
    if (data?.getUser) {
      setUserData(data.getUser)
      setCurrentUser(data.getUser)
      editProfileEvent({
        type: 'CHANGE_PROFILE',
        payload: { profileData: data.getUser }
      })
    }
  }

  return (
    <>
      {/* FOR PHASE 2 */}
      <Dropdown className={`${styles.userDropdown} user-dropdown`}
        onClick={() => {
          if (!isAuthenticated) {
            setModalShow(true)
          }
        }}
      >
        <Dropdown.Toggle variant="link" id="dropdown-basic" className={`d-flex align-items-center ${styles.userToggle}`}>
          <div className={`${styles.userProfileImage} ${!getImgURL(userData?.sProPic) && styles.userImg} rounded-circle overflow-hidden`}>
            {getImgURL(userData?.sProPic) ? <MyImage loading='lazy' src={getImgURL(userData?.sProPic)} alt="user name" width="22" height="22" layout="responsive" errorImage={ProfilePlaceholder} /> : <UserProfileIcon />}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.dropdownMenu} align="end">
          {
            isAuthenticated && (
              <>
                <Dropdown.Item as="div">
                  <CustomLink href={allRoutes.profile} prefetch={false}>
                    <a className="d-block">
                      {t('common:Profile')}
                    </a>
                  </CustomLink>
                </Dropdown.Item>
                <Dropdown.Item onClick={handleSignOut} as="button">{`${t('common:SignOut')}`}</Dropdown.Item>
              </>
            )
          }
        </Dropdown.Menu>
      </Dropdown>
      {
        width > 768 && (
          <div className="d-none d-md-block">
            <GlobalSearch handleOpen={setSearchModalShow} />
          </div>
        )
      }
      {
        modalShow && (
          <SocialAuthModal show={modalShow}
            onHide={() => {
              setModalShow(false)
            }} />
        )
      }
      {
        searchModalShow && (
          <SearchModal show={searchModalShow}
            onHide={() => {
              setSearchModalShow(false)
            }} />
        )
      }
    </>
  )
}

HeaderUser.propTypes = {
  styles: PropTypes.object
}
export default HeaderUser
